import { TeamCompositionGrid as TeamCompositionGridComponent } from './TeamCompositionGrid.component';
import { connector } from './TeamCompositionGrid.connector';

export const TeamCompositionGrid = connector(TeamCompositionGridComponent);
